module.exports = __webpack_public_path__ + "static/media/x-4-mtn.dcab099e.svg";